import { render } from "./ViewDoctor.vue?vue&type=template&id=65dc1120&scoped=true"
import script from "./ViewDoctor.vue?vue&type=script&lang=js"
export * from "./ViewDoctor.vue?vue&type=script&lang=js"

import "./ViewDoctor.vue?vue&type=style&index=0&id=65dc1120&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65dc1120"]])

export default __exports__